// Utility functions for subdomain detection and church routing

export const getDomainInfo = () => {
  if (typeof window === 'undefined') return { domain: null, subdomain: null, isMarketing: false, isHub: false };
  
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  console.log('🌐 Domain detection:', { hostname, parts });
  
  // For development (localhost, preview URLs)
  if (hostname.includes('localhost')) {
    console.log('🔧 Development environment detected');
    return { domain: 'development', subdomain: null, isMarketing: false, isHub: true };
  }
  
  // Check for churchhub.us (marketing site) - more flexible matching
  if (hostname === 'churchhub.us' || hostname === 'www.churchhub.us') {
    console.log('🎯 Marketing site detected:', hostname);
    return { domain: 'churchhub.us', subdomain: null, isMarketing: true, isHub: false };
  }
  
  // Fallback: check the traditional way for churchhub.us
  if (parts.length >= 2 && parts[parts.length - 2] === 'churchhub' && parts[parts.length - 1] === 'us') {
    console.log('🎯 Marketing site detected (fallback):', hostname);
    return { domain: 'churchhub.us', subdomain: null, isMarketing: true, isHub: false };
  }
  
  // Check for churchhub.live (hub)
  if (parts.length >= 2 && parts[parts.length - 2] === 'churchhub' && parts[parts.length - 1] === 'live') {
    const subdomain = parts.length >= 3 ? parts[0] : null;
    // Ignore www and common subdomains
    if (subdomain && (subdomain === 'www' || subdomain === 'api' || subdomain === 'admin')) {
      console.log('🏠 Hub site detected (no subdomain):', hostname);
      return { domain: 'churchhub.live', subdomain: null, isMarketing: false, isHub: true };
    }
    console.log('⛪ Church subdomain detected:', { hostname, subdomain });
    return { domain: 'churchhub.live', subdomain, isMarketing: false, isHub: true };
  }
  
  console.log('❓ Unknown domain:', hostname);
  return { domain: hostname, subdomain: null, isMarketing: false, isHub: false };
};

export const getSubdomain = (): string | null => {
  const { subdomain } = getDomainInfo();
  return subdomain;
};

export const isChurchSubdomain = (): boolean => {
  return getSubdomain() !== null;
};

export const isMarketingSite = (): boolean => {
  const { isMarketing } = getDomainInfo();
  return isMarketing;
};

export const isHubSite = (): boolean => {
  const { isHub } = getDomainInfo();
  return isHub;
};

export const getChurchUrl = (subdomain: string): string => {
  return `https://${subdomain}.churchhub.live`;
};

export const getMainAppUrl = (): string => {
  // For development, use current origin
  if (typeof window !== 'undefined' && window.location.hostname.includes('localhost')) {
    return window.location.origin;
  }
  
  // For production, use the main app domain
  return 'https://churchhub.live';
};

export const getMarketingUrl = (): string => {
  return 'https://churchhub.us';
};

// For development/testing - you can override subdomain detection
export const getTestSubdomain = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('church') || getSubdomain();
};